<template>
  <div class="home">
    <PageHeader title="Marketplace"
                :shouldDisplayCart="true"
                v-loading.fullscreen.lock="loading"
                @displayCartPreview="displayCartPreview"></PageHeader>
    <Home v-if="!this.loading"
          :msg="$t('home.title')"
          :items="this.products"
          :suppliers="suppliers"></Home>
    <CartPreview v-if="cartPreview"
                 :display-drawer="cartPreview"
                 :cartBySupplier="cartBySupplier"
                 @closeCartPreview="closeCartPreview"
                 class="cart-preview">
    </CartPreview>
    <el-alert
      v-if="alert"
      title="Aucun fournisseur ne vous est attribué actuellement"
      type="error"
      show-icon
      effect="dark">
    </el-alert>
  </div>
</template>

<script>
  // @ is an alias to /src
  import Home from '@/components/Home.vue';
  import CartPreview from '../../components/CartPreview/CartPreview.vue';
  import PageHeader from '../../components/PageHeader/PageHeader.vue';

  export default {
    components: {
      PageHeader,
      Home,
      CartPreview,
    },
    data() {
      return {
        cartPreview: false,
        loading: true,
        alert: false,
      };
    },
    mounted() {
      this.$mixpanel.track('Page d\'accueil', {
        app_mb: process.env.VUE_APP_NAME,
      });
      this.fetchData();
    },
    computed: {
      products() {
        return this.$store.getters['products/totalProducts'];
      },
      suppliers() {
        return this.$store.getters['supplier/suppliersByShopId'];
      },
      suppliersName() {
        return this.$store.getters['supplier/suppliersName'];
      },
      shopId() {
        return this.$store.getters['shopAuth/currentShopId'];
      },
      shopName() {
        return this.$store.getters['shopAuth/shopName'];
      },
      shopInfo() {
        return this.$store.getters['shopAuth/currentShopInfo'];
      },
      cartBySupplier() {
        return this.$store.getters['cart/cartBySupplier'];
      },
    },
    // TODO: change id to codeSupplier+supplier
    methods: {
      async fetchData() {
        await this.$store.dispatch('auth/loginBo');
        await this.$store.dispatch('settings/settings');
        await this.$store.dispatch('supplier/list', this.shopId);
        await this.$store.dispatch('shopAuth/getShopName', this.shopId)
          .then(() => {
            this.loading = false;
          })
          .catch(() => {
            this.$store.dispatch('auth/logout');
            this.$router.push({ name: 'Login' });
            this.showNoShopMessage();
            this.alert = true;
          });
        await this.$store.dispatch('shopAuth/getShopInfo', this.shopId);
        this.$store.dispatch('products/list', {
          suppliers: this.suppliersName,
          id: this.shopId,
          token: this.$store.getters['auth/boToken'],
        })
          .then(() => {
            this.loading = false;
          })
          .catch(() => {
            this.loading = false;
            this.alert = true;
          });
        await this.$store.dispatch('history/lastHistory', this.shopId);
      },
      async displayCartPreview() {
        this.cartPreview = true;
      },
      closeCartPreview() {
        this.cartPreview = false;
      },
      showNoShopMessage() {
        this.$message({
          type: 'warning',
          message: 'Votre magasin n\'a pas encore de fournisseur attribué, cela arrive bientôt!',
        });
      },
    },
  };
</script>

<style lang="stylus">
  .cart-preview {
  }
</style>
